import { useEffect, useState } from 'react';
import { useDebounce } from '@/hooks/debounce';
import { Input } from '@/components/ui';

export function UserSearch({
  label,
  className,
  onChange,
  debounce = 400,
}: {
  label?: string;
  className?: string;
  onChange?: (value: string) => void;
  debounce?: number;
}) {
  const [input, setInput] = useState('');
  const value = useDebounce(input, debounce);
  useEffect(() => {
    onChange?.(value);
  }, [value, onChange]);

  return (
    <Input
      isClearable
      placeholder='Search by name or email...'
      value={input}
      label={label}
      onValueChange={setInput}
      className={className}
      autoComplete='off'
    />
  );
}
